import PropTypes from 'prop-types';
//
import Image from '../../image';

// ----------------------------------------------------------------------

SingleFilePreview.propTypes = {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  imageUrl: PropTypes.string,
};

export default function SingleFilePreview({ file, imageUrl }) {
  // Determine the image source
  let imgUrl = imageUrl; // Default to imageUrl prop

  if (file) {
    imgUrl = typeof file === 'string' ? file : file.preview;
  }

  // If no image source is available, don't render
  if (!imgUrl) {
    return null;
  }

  return (
    <Image
      alt="file preview"
      src={imgUrl}
      sx={{
        top: 8,
        left: 8,
        zIndex: 8,
        borderRadius: 1,
        position: 'absolute',
        width: 'calc(100% - 16px)',
        height: 'calc(100% - 16px)',
      }}
    />
  );
}
